import icon from "../static files/images/scroll-bar.png";
import "../static files/styles/pages.css";



const DownMouse =()=>{

    return(
        <div className="scroll-bar">
            <img src={icon} alt="Metal Konstruksiya" />
            <p>Davam etmək üçün</p>
        </div>
    )
}


export default DownMouse;